var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAqikon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 67.72C52.5734 67.72 67.6301 52.6633 67.6301 34.09C67.6301 15.5167 52.5734 0.459991 34.0001 0.459991C15.4268 0.459991 0.370117 15.5167 0.370117 34.09C0.370117 52.6633 15.4268 67.72 34.0001 67.72Z",
    fill: "#23CBD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 27.39C23.7501 27.39 25.5601 25.45 27.3601 23.52C30.5301 20.12 33.6801 16.74 42.8701 16.74V26C37.8201 26 36.0901 27.86 34.3401 29.74C31.1501 33.16 27.9301 36.61 18.4101 36.61V27.38L18.4001 27.39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.55 41.32C30.9 41.32 32.71 39.38 34.51 37.45C37.68 34.05 40.8301 30.67 50.0201 30.67V39.93C44.9701 39.93 43.24 41.79 41.49 43.67C38.3 47.1 35.08 50.55 25.56 50.54V41.31L25.55 41.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqikon);
export default __webpack_public_path__ + "static/media/AQ IKON.e606c6a179767f60059465871e289f1d.svg";
export { ForwardRef as ReactComponent };